import React from 'react';

import Box from '@mui/material/Box';

import MediaPlayer from '@ts-core/modules/media/components/MediaPlayer';

import { ExerciseMediaItem } from '../../types';

interface ExerciseMediaItemProps {
  item: ExerciseMediaItem;
}

const ExerciseMediaItemPreview = (props: ExerciseMediaItemProps) => {
  const { item } = props;

  if (item.type === 'image') {
    return <Box component="img" src={item.url} alt={item.url} width="100%" />;
  }

  return <MediaPlayer media={item} showNameWhenProcessing />;
};

export default ExerciseMediaItemPreview;
